import { useContext } from 'react';
import { Box, Theme, useTheme } from '@mui/material';
import ConfigurationWrapper from '../../components/shared/ConfigurationWrapper';
import { ReactComponent as ReportingPeriodIcon } from '../../assets/icons/Date Month.svg';
import { ReactComponent as ReportingPeriodGroupIcon } from '../../assets/icons/Date Year.svg';
import { ReactComponent as ExternalCompaniesIcon } from '../../assets/icons/Company External.svg';
import PanelReportingPeriods from '../../components/configuration/reporting_periods/PanelReportingPeriods';
import { useModuleDurationTracking } from '../../hooks/useModuleDurationTracking';
import { GroupContext } from '../../context/GroupContext';
import { CompanyContext } from '../../context/CompanyContext';

const ConfigurationReportingPeriods = () => {
  const { group } = useContext(GroupContext);
  const { company } = useContext(CompanyContext);

  if (!group || !company) return null;

  // Track module duration.
  useModuleDurationTracking('Configuration', 'Reporting Periods', group.id, company.id);

  const theme: Theme = useTheme();
  const primary_blue: string = theme.palette.primary.main;
  const dark_teal: string = theme.palette.teal.dark;

  return (
    <Box>
      <ConfigurationWrapper
        title="Reporting Periods"
        icon={<ReportingPeriodIcon height={50} fill={primary_blue} stroke={primary_blue} />}
        previous={{
          route: '/configuration/external-companies',
          label: 'External Companies',
          icon: <ExternalCompaniesIcon height={30} fill={dark_teal} stroke={dark_teal} />
        }}
        next={{
          route: '/configuration/reporting-period-groups',
          label: 'Reporting Period Groups',
          icon: <ReportingPeriodGroupIcon height={30} fill={dark_teal} stroke={dark_teal} />
        }}
      >
        <PanelReportingPeriods />
      </ConfigurationWrapper>
    </Box>
  );
};

export default ConfigurationReportingPeriods;
